import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMABAA080AdminRegisterBanner, postMABAA080RecruitReRegExtra } from '../../../../services/Api';
import { formatDate, formatDatePayload, handleFocus } from '../../../../utils';
import moment from 'moment';
const PopupMABAA080_4 = ({ onClose, additionalData }) => {
    const { memberID, recruitSeq, recruitFrom, recruitEnd, title } = additionalData;
    const [popupDataComment, setPopupDataComment] = useState([]);
    const [popupDataCompanyName, setPopupDataCompanyName] = useState('');
    const [payload, setPayload] = useState({
        memberID,
        recruitFrom,
        recruitSeq,
        recruitEnd,
        goodCode: '',
        comment: '',
        payStatus: '',
        actInputName: '',
    });

    useEffect(() => {
        getMABAA080AdminRegisterBanner({
            params: {
                memberID,
                recruitSeq,
            },
        })
            .then(({ data }) => {
                setPopupDataComment(data.comments);
                setPopupDataCompanyName(data.companyName);
            })
            .catch((error) => console.log(error));
    }, [memberID, recruitSeq]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (!payload.goodCode) {
            alert('상품명을 입력해 주세요.');
            handleFocus('goodCode');
            return;
        }

        if (!payload.extraFrom) {
            alert('강조 시작일을 선택해 주세요.');
            handleFocus('extraFrom');
            return;
        }
        const formattedExtraFrom = formatDatePayload(payload.extraFrom);
        const formattedRecruitFrom = formatDatePayload(payload.recruitFrom);

        if (formattedExtraFrom < formattedRecruitFrom) {
            alert('강조 시작일이 채용 시작일 이전입니다.강조 시작일을 확인하세요.');
            handleFocus('extraFrom');
            return;
        }

        if (!payload.extraEnd) {
            alert('강조 종료일을 선택해 주세요.');
            handleFocus('extraEnd');
            return;
        }

        const formattedExtraEnd = formatDatePayload(payload.extraEnd);
        const formattedRecruitEnd = formatDatePayload(payload.recruitEnd);

        if (formattedExtraEnd > formattedRecruitEnd) {
            alert('강조 종료일이 채용 종료일 이후입니다.강조 종료일을 확인하세요.');
            handleFocus('extraEnd');
            return;
        }

        if (!payload.payStatus) {
            alert('결제여부를 선택해 주세요.');
            handleFocus('payStatus');
            return;
        }

        if (formattedRecruitFrom > formattedRecruitEnd) {
            alert('채용 종료일이 채용 시작일 이전입니다.');
            handleFocus('recruitFrom');
            return;
        }

        const formattedApplDate = moment(payload.applDate).format('YYYYMMDD');

        const updatedPayload = {
            ...payload,
            extraFrom: formattedExtraFrom,
            extraEnd: formattedExtraEnd,
            recruitFrom: formattedRecruitFrom,
            recruitEnd: formattedRecruitEnd,
            applDate: formattedApplDate,
            recruitSeq: recruitSeq,
        };
        postMABAA080RecruitReRegExtra(updatedPayload)
            .then(() => {
                alert('강조 상품 등록이 완료되었습니다.');
                onClose();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="dental-information" className="dental-information">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={onClose} />
                        <div className="popup-header">[강조추가]</div>
                        <div className="popup-title">진행중인 채용광고에 강조추가등록 - 신규강조추가등록</div>
                        <div className="table-dental-information">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>아이디</td>
                                        <td>{memberID}</td>
                                        <td>치과명</td>
                                        <td>{popupDataCompanyName}</td>
                                    </tr>
                                    <tr>
                                        <td>제목</td>
                                        <td colSpan={3}>{title}</td>
                                    </tr>
                                    <tr>
                                        <td>채용시작일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitFrom', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitFrom || ''}
                                                maxDate={payload.recruitEnd || null}
                                                id="recruitFrom"
                                            />
                                        </td>
                                        <td>채용종료일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'recruitEnd', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.recruitEnd || ''}
                                                minDate={payload.recruitFrom || null}
                                                id="recruitEnd"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>상품명</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="goodCode" onChange={handleInputChange}>
                                                    <option value="000">상품구분</option>
                                                    <option value="3021">아이콘강조(HOT)(체험)</option>
                                                    <option value="3200">아이콘강조(HOT)(추가)</option>
                                                    <option value="3011">아이콘강조(주목)(체험)</option>
                                                    <option value="3100">아이콘강조(주목)(추가)</option>
                                                    <option value="3521">아이콘강조2(HOT)(체험)</option>
                                                    <option value="3529">아이콘강조2(HOT)(추가)</option>
                                                    <option value="3511">아이콘강조2(주목)(체험)</option>
                                                    <option value="3519">아이콘강조2(주목)(추가)</option>
                                                    <option value="2001">컬러강조(체험)</option>
                                                    <option value="2100">컬러강조(추가)</option>
                                                    <option value="2501">컬러강조2(체험)</option>
                                                    <option value="2510">컬러강조2(추가)</option>
                                                    <option value="1001">하이라이트강조(체험)</option>
                                                    <option value="1100">하이라이트강조(추가)</option>
                                                    <option value="1501">하이라이트강조2(체험)</option>
                                                    <option value="1510">하이라이트강조2(추가)</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>입금자명</td>
                                        <td>
                                            <input type="text" name="actInputName" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>강조시작일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'extraFrom', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.extraFrom || ''}
                                                maxDate={payload.extraEnd || null}
                                                id="extraFrom"
                                            />
                                        </td>
                                        <td>강조종료일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'extraEnd', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.extraEnd || ''}
                                                minDate={payload.extraFrom || null}
                                                id="extraEnd"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>결제여부</td>
                                        <td>
                                            <div className="select-box">
                                                <select name="payStatus" id="payStatus" onChange={handleInputChange}>
                                                    <option value="">선택</option>
                                                    <option value="Y">결제</option>
                                                    <option value="N">미결제</option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>결제일</td>
                                        <td>
                                            <DatePicker
                                                onChange={(date) =>
                                                    handleInputChange({ target: { name: 'applDate', value: date } })
                                                }
                                                locale={'ko'}
                                                placeholderText={'YYYY/MM/DD'}
                                                dateFormat={'yyyy/MM/dd'}
                                                selected={payload.applDate || ''}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comment</td>
                                        <td colSpan={3}>
                                            <textarea name="comment" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="note-table">
                            ※ Comment 등록형식 : [상품명]/ [Comment]. ex) 프리미엄배너 / 전화가 안와요 불만)
                            <br />
                            ※ 새로운 채용광고로 등록됩니다. 기간연장은 재사용 버튼을 사용하세요.
                            <br />※ 상품명 중 덴탈잡이 포함된 상품은 유료상품입니다.
                        </div>
                        <div className="group-btn">
                            <button className="popup-button" onClick={handleSave}>
                                등록 / 수정
                            </button>
                        </div>
                        <div className="table-comment-results">
                            <div className="table-comment-results-title">
                                등록된 Comment (
                                {popupDataComment && popupDataComment.length > 0 ? popupDataComment.length : 0})
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th>Seq</th>
                                        <th>등록일</th>
                                        <th>관리자명</th>
                                        <th>등록사이트</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {popupDataComment && popupDataComment.length > 0 ? (
                                        popupDataComment.map((item) => (
                                            <tr key={item.seq}>
                                                <td>{item.seq}</td>
                                                <td>{formatDate(item.addDate)}</td>
                                                <td>{item.adminName}</td>
                                                <td>{item.sitePos}</td>
                                                <td>{item.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                데이타가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMABAA080_4;
